import { SessionStatus } from '@/lib/types/session-status';
import { SessionHub } from '@addmile/backend-client';

export const countSessionsByType = (
  sessions: SessionHub[],
  statuses: typeof SessionStatus,
): Record<keyof typeof SessionStatus, number> => {
  return Object.keys(statuses).reduce(
    (counts, key) => {
      const statusKey = key as keyof typeof SessionStatus;
      counts[statusKey] = sessions.filter(
        (session) => session.status === statuses[statusKey],
      ).length;
      return counts;
    },
    {} as Record<keyof typeof SessionStatus, number>,
  );
};
